import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Button} from 'semantic-ui-react';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import OrdersList from './list';
import './authorizationList.scss';

class AuthorizationList extends Component {
  constructor(props) {
    super(props);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  componentDidMount() {
    const {permissions} = this.props;

    if (!hasAccessPermission(permissions, resources.ProviderOrdersAuthorization, scopes.Edit)) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.props.getProviderOrdersAuthorizationList();
  }

  handleUpdate() {
    this.props.getProviderOrdersAuthorizationList();
  }

  render() {
    return (
      <div className='provider-authorization-orders'>
        <Card raised fluid className='authorization-orders-header'>
          <Grid>
            <Grid.Row>
              <Grid.Column width='12' textAlign='left'>
                <h2>Pedidos Pendientes de Autorización</h2>
              </Grid.Column>
              <Grid.Column width='4' textAlign='right'>
                <Button secondary content='ACTUALIZAR' onClick={this.handleUpdate} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <Card raised fluid className='authorization-orders-body'>
          <OrdersList />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
  };
};

const {getProviderOrdersAuthorizationList, navigateTo} = Actions;

export default connect(mapStateToProps, {
  getProviderOrdersAuthorizationList,
  navigateTo,
})(AuthorizationList);
